module.exports = __webpack_public_path__ + "57bf0bdb6b44b6c240d03cd975fd735d.jpg";